import { ScFormGroup } from 'components/form/groups/styled';
import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components';

export const ScCompleteUserGameData = styled.div`
  position: relative;
  color: ${({ theme }) => theme.whiteColor};
  display: grid;
  gap: 32px;

  & > .header {
    display: grid;
    gap: 8px;
    text-align: center;

    & > .title {
      text-transform: capitalize;
      font-size: 22px;
      line-height: 28px;
      font-weight: 700;
      letter-spacing: 0.22px;

      @media (${device.mobile}) {
        padding-inline: 32px;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: 0.18px;
      }
    }

    & > .description {
      font-size: 16px;
      line-height: 28px;
      letter-spacing: 0.16px;
      color: ${({ theme }) => theme.grayColor1};
      @media (${device.mobile}) {
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0px;
      }
    }
  }

  & ${ScFormGroup} {
    margin-bottom: 24px;
    h3 {
      padding-left: 16px;
    }
  }
  .submit-container {
    display: flex;
    margin: 0 auto;
    padding-top: 8px;
    max-width: 232px;
    @media (${device.mobile}) {
      max-width: none;
    }
  }
`;
